import styled from 'styled-components/macro';

export const DefaultErrorMessage = styled.p`
  color: red;
  font-size: '1em';
  text-align: 'center';
  padding: '5px';
`;
